import { render, staticRenderFns } from "./bed.vue?vue&type=template&id=8fcd54c4&scoped=true"
import script from "./bed.vue?vue&type=script&lang=js"
export * from "./bed.vue?vue&type=script&lang=js"
import style0 from "./bed.vue?vue&type=style&index=0&id=8fcd54c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fcd54c4",
  null
  
)

export default component.exports